<div class="container">
  <div (click)="close()" class="close">
    <img src="./assets/images/Close_Modal_visa.png" alt="close">
  </div>
  <div class="container-txtMain">
    <span>{{"paxForms.visa.search_visa" | translate}}</span>
  </div>
  <div class="d-flex">
  <div class="d-flex flex-column firstColumn">
    <div class="txt-express">
      <span>{{"paxForms.visa.modal_visa_express" | translate}}</span>
    </div>
    <div class="txt-8digits">
      <span>{{"paxForms.visa.modal_visa_8_digits" | translate}}</span>
    </div>
    <div class="img-ml">
      <img src="./assets/images/Card_Visa.png" alt="express">
    </div>
  </div>
  <div class="column2">
    <div class="txt-express">
      <span>{{"paxForms.visa.modal_visa_laser" | translate}}</span>
    </div>
    <div class="txt-8digits">
      <span>{{"paxForms.visa.modal_visa_3_letters" | translate}}</span>
    </div>
    <div class="img-ml">
      <img src="./assets/images/Card_Visa_back.png" alt="laser">
    </div>
  </div>
</div>
</div>